import React, { useEffect, useRef } from 'react';

// Sample Data
const candleData = [
  { day: 'Day 1', open: 120, high: 250, low: 100, close: 230 },
  { day: 'Day 2', open: 130, high: 145, low: 110, close: 125 },
  { day: 'Day 3', open: 115, high: 150, low: 105, close: 140 },
  { day: 'Day 4', open: 140, high: 160, low: 120, close: 150 },
  { day: 'Day 5', open: 125, high: 155, low: 110, close: 140 },
];

const CandleChart = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    const width = canvas.width;
    const height = canvas.height;

    // Clear the canvas
    ctx.clearRect(0, 0, width, height);

    // Chart configuration
    const padding = 40;
    const chartWidth = width - 2 * padding;
    const chartHeight = height - 2 * padding;
    const maxPrice = Math.max(...candleData.map(d => d.high));
    const minPrice = Math.min(...candleData.map(d => d.low));

    // Helper to convert prices to Y position in canvas
    const priceToY = (price) => {
      return padding + chartHeight - ((price - minPrice) / (maxPrice - minPrice)) * chartHeight;
    };

    const candleWidth = chartWidth / candleData.length - 20;
    const candleSpacing = (chartWidth - candleData.length * candleWidth) / (candleData.length + 1);

    // Draw the chart grid
    ctx.strokeStyle = '#ddd';
    ctx.lineWidth = 2;
    ctx.font = '16px Arial'; 
    ctx.fillStyle = 'white';  

    for (let i = 0; i <= 5; i++) {
      const y = padding + (i / 5) * chartHeight;
      ctx.beginPath();
      ctx.moveTo(padding, y);
      ctx.lineTo(width - padding, y);
      ctx.stroke();
      ctx.fillText(`${minPrice + (maxPrice - minPrice) * (1 - i / 5)}`, 5, y);
    }

    // Draw the candlestick data
    candleData.forEach((entry, index) => {
      const x = padding + candleSpacing + index * (candleWidth + candleSpacing);
      const openY = priceToY(entry.open);
      const closeY = priceToY(entry.close);
      const highY = priceToY(entry.high);
      const lowY = priceToY(entry.low);

      // High-Low line
      ctx.beginPath();
      ctx.moveTo(x + candleWidth / 2, highY);
      ctx.lineTo(x + candleWidth / 2, lowY);
      ctx.strokeStyle = entry.close >= entry.open ? 'green' : 'red';
      ctx.stroke();

      // Open-Close rectangle (candlestick body)
      ctx.fillStyle = entry.close >= entry.open ? 'green' : 'red';
      ctx.fillRect(x, Math.min(openY, closeY), candleWidth, Math.abs(openY - closeY));
    });
  }, []);

  return (
    <div className="candle-chart">
      <canvas ref={canvasRef} width={600} height={400} />
    </div>
  );
};

export default CandleChart;
